var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.856,
    height: 30,
    viewBox: "0 0 22.856 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_38",
    "data-name": "Union 38",
    d: "M-4459-8266.428a11.432,11.432,0,0,1,7.17-10.607l-3.616-4.206,4.178-3.759h7.639l4.176,3.759-3.679,4.281a11.428,11.428,0,0,1,6.988,10.532A11.426,11.426,0,0,1-4447.572-8255,11.427,11.427,0,0,1-4459-8266.428Zm2.547,0a8.89,8.89,0,0,0,8.881,8.881,8.89,8.89,0,0,0,8.881-8.881,8.9,8.9,0,0,0-6.213-8.472l-2.545,2.962-2.6-3.021A8.9,8.9,0,0,0-4456.453-8266.428Zm10.62-11.295,2.828-3.29-1.6-1.44h-5.685l-1.6,1.44,2.8,3.259a11.618,11.618,0,0,1,1.518-.1A11.593,11.593,0,0,1-4445.833-8277.723Z",
    transform: "translate(4459 8285)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring__icon.894d4b5576eb901fe5c96cf52b8e2ab6.svg";
export { ForwardRef as ReactComponent };